import { render, staticRenderFns } from "./CustomerDataRow.vue?vue&type=template&id=5ca37d4a"
import script from "./CustomerDataRow.vue?vue&type=script&lang=js"
export * from "./CustomerDataRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports